import request from '../utils/request'

// const rentalHost = 'https://script.google.com/macros/s/AKfycbyqNwrLImrcWaQxE1WpVqy-ujuKHuBDHj5TNSDry1OuCKmxzrIK/exec'
const rentalHost =
  'https://script.google.com/macros/s/AKfycbyz9vXeZU85tsFVlmQnK2c5yfNYqogsmC8tk1ElRv3Z7-vPe8apHKgwtBXsmjMtY43giw/exec'

export function getRentalsFromCalendar() {
  return request(rentalHost).getJson()
}
